export class AdminStateModel {
  overview: AdminOverview;
  organizations: AdminOrganizationListItem[];
  users: AdminUserListItem[];
  user: AdminUser;
  organization: AdminOrganization;
}

export class AdminOverview {
  activities: AdminOverviewActivity[];
}

export class AdminOverviewActivity {
  id: string;
  name: string;
  organizationId: string;
  organizationName: string;
  organizationLogoUrl: string;
  type: string;
  created: Date;
  participantCount: number;
  imageUrl: string;
}

export class AdminOrganizationBase {
  id: string;
  name: string;
  outboundEmailAddress: string;
  demoMode: boolean;
  verified: boolean;
  smsEnabled: boolean;
  logoUrl: string;
  currentActivityCount: number;
  archivedActivityCount: number;
}

export class AdminOrganizationListItem extends AdminOrganizationBase {
  lastBilled: Date;
  notBilledSmsCount: number;
  children: AdminOrganizationListItem[];
  administratorCount: number;
  administratorRequestCount: number;
}

export class AdminOrganization extends AdminOrganizationBase {
  parentOrganizationId: string;
  parentOrganizationName: string;
  defaultOutboundEmailAddress: string;
  administrators: AdminUserBase[];
  notBilledSmsGroups: NotBilledSmsGroup[];
  storageSize: string;
}

export class NotBilledSmsGroup {
  text: string;
  count: number;
}

export class AdminUserBase {
  id: string;
  name: string;
  email: string;
  isSuperAdministrator: boolean;
  phone: string;
  profileImageUrl: string;
  lastLogin: Date;
  fromParentOrganization: boolean;
}

export class AdminUserListItem extends AdminUserBase {
  organizationCount: number;
  identityProviders: string[];
}

export class AdminUser extends AdminUserBase {
  organizations: AdminUserOrganization[];
  originalEmal: string;
  lastIdentityProvider: string;
}

export class AdminUserOrganization {
  id: string;
  name: string;
  logoUrl: string;
}
